import { render, staticRenderFns } from "./HowWorksCarousel.vue?vue&type=template&id=b52af59a&scoped=true"
import script from "./HowWorksCarousel.vue?vue&type=script&lang=js"
export * from "./HowWorksCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52af59a",
  null
  
)

export default component.exports